// extracted by mini-css-extract-plugin
export default {"section":"Section_section__mcWrY","section__heading":"Section_section__heading__HvROE","section__list":"Section_section__list__bfHZ9"};